import React from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import logo1 from './Assets/logonew.png'
const AdminNav = () => {

  const navigate = useNavigate();

  const logoutFun = () => {
    sessionStorage.clear();
    navigate('/')
  }
  const handlePasswordChange = () => {
    navigate('/passwordChange');
  };

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;
    const Name = userdata ? userdata.branch_name : '';
  return (
<Container>
    <Row  className='py-2'>
        <Col  style={{display:"flex",alignItems: "center",justifyContent:"start"}}>
        <img src={logo1} alt="Logo" style={{mixBlendMode:"darken"}} width={120} height={80} />
        </Col>

        <Col  style={{ display: "flex", alignItems: "center",justifyContent:"center" }}> 
        <h2 style={{fontFamily:"initial"}}><b>{Name}</b></h2>
        </Col>

        <Col  style={{ display: "flex", alignItems: "center",justifyContent:"end" }}>
            {/* <Nav.Link className='px-2 py-1' style={{border:"1px solid #3d3d3d",borderRadius:"5px"}}><b><i class="fa-solid fa-user" title={user.name}></i>&nbsp;&nbsp;</b>{user.name}</Nav.Link> */}
            <Nav>
              <Dropdown>
                <Dropdown.Toggle className='px-2 py-1' style={{ border: "1px solid #3d3d3d", borderRadius: "5px", backgroundColor: "transparent", color: "blue" }}>
                  <b><i className="fa-solid fa-user" title="Admin"></i>&nbsp;&nbsp;</b>Admin
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className='navName' onClick={handlePasswordChange}>Change Password</Dropdown.Item>
                  <Dropdown.Item className='fs-md-5 navName' onClick={logoutFun}>Log-Out &nbsp;&nbsp;<i class="fa-solid fa-right-from-bracket" style={{color:"rgb(254, 105, 129)"}}></i></Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Col>
    </Row>
    </Container>

  )
}

export default AdminNav
